<template>
    <div>
        <div class="top-nav">
            <router-link @click="go" to="" class="icon icon-arrow-left"></router-link>
            <h1>{{ $route.meta.title }}</h1>  
        </div>
        <router-view></router-view>
        <Feedback></Feedback>
    </div>
</template>
<style lang="less" scoped>
    @import "~assets/less/icon.less";
    .top-nav{
       padding:20px 50px;
       border-bottom:2px solid #f1f1f1;
       overflow: hidden;
       position: relative;
       height:50px;
       a.icon{
         display:block;        
         position: absolute;
         left:10px;
         top:5px;
       }
       h1{
         position: absolute;
         left:50%;
         top:50%;
         color:#00BE82;
         transform: translate(-50%,-50%);
         font-size: 40px;
       }
    }
</style>
<script>

import Feedback from '../components/feedback.vue'
export default {
    components:{
        Feedback
    },
    methods:{
        go () {
            this.$router.go(-1)
        }
    }
}
</script>